import { Typography } from "antd";

const { Title, Text } = Typography;

const PageHeader = ({ screens }) => (
  <div className="relative text-center mb-4">
    <Title
      level={screens.xs ? 4 : 3}
      className="!mb-0 !text-white !text-4xl font-mono"
    >
      Data Schema & Analytics <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">Configuration</span>
    </Title>
    <Text type="secondary" className="!text-white !text-lg !mt-4 font-serif">
      Manage your uploaded files and configure analytics. Review your dataset structure and configure analytics parameters for optimal model performance.
    </Text>
  </div>
);

export default PageHeader;